import React from 'react';
import {Link} from 'react-router-dom';
import {Formik, Field, FormikProps} from 'formik';

import {Layouts, Form, Button} from '@components';
import validate from '@validations';
import paths from '@paths';
import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const Main: React.FC<Props> = props => {
  const initialValues = {email: ''};

  return (
    <div className="a__reset-password">
      <Layouts.Header.Before
        history={props.history}
        match={props.match}
        location={props.location}
      />
      <div className="w__field">
        <div className="b__title">認証コードの再送信</div>
        <div className="b__message">
          メールアドレス宛に認証コードを再送信します。
          <br />
          メールアドレスを入力してください。
          <br />
          認証コードの再送信が必要が無ければ
          <Link to={paths.signIn.main} className="b__sign-in">
            ログイン
          </Link>
          してください。
          <div className="w__form">
            <Formik
              initialValues={initialValues}
              onSubmit={async (value, formikAction) =>
                await handlers.sendResetMail(value, formikAction, props)
              }
              validate={validate.users.resetPasswordMain}
            >
              {(formProps: FormikProps<any>) => {
                return (
                  <>
                    <Field
                      component={Form.Input}
                      name="email"
                      placeholder="メールアドレス"
                    />
                    <Button.Normal
                      color="yellow"
                      text="メールを送信する"
                      className="b__button"
                      rounded
                      loading={formProps.isSubmitting}
                      disabled={formProps.isSubmitting}
                      onClick={() => {
                        formProps.handleSubmit();
                      }}
                    />
                  </>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
      <Layouts.Footer.Main />
    </div>
  );
};

export default Main;
